import { Modal, Text, Tabs, Button, Divider, Grid, Row, Col } from 'rsuite';
import { isNullUndefinedOrEmptyObject } from '../../common/utils';
import IconIndicator from '../user-feedback/IconIndicator';
import { TAX_PAYMENT_PERIOD_TYPES_ENUM } from '../../common/enums';
import ResponsiveModal from '../ResponsiveModal';
import React, { useMemo, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import { BREAKPOINT_ENUM } from '../../common/enums';
import BasicStyledCheckbox from '../form/BasicStyledCheckbox';

const AddAdditionalPeriodsModal = ({
  availabelReportingPeriods,
  updateAvailableReportingPeriods,
  isOpen,
  setOpen,
  taxPaymentPeriod,
}) => {
  const closeModal = () => setOpen(false);

  const hasData = !isNullUndefinedOrEmptyObject(availabelReportingPeriods);
  const years = Array.from(
    new Set(availabelReportingPeriods?.map((item) => item.year))
  );

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < BREAKPOINT_ENUM.SMALL
  );

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMobile(window.innerWidth < BREAKPOINT_ENUM.SMALL);
    });

    if (isOpen) {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isOpen]);

  const gridTemplateColumn = useMemo(() => {
    if (
      taxPaymentPeriod === TAX_PAYMENT_PERIOD_TYPES_ENUM.QUARTERLY ||
      taxPaymentPeriod === TAX_PAYMENT_PERIOD_TYPES_ENUM.NY_FISCAL
    ) {
      return 'repeat(1, 1fr)';
    } else {
      return isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)';
    }
  }, [taxPaymentPeriod, isMobile]);

  const gridTemplateRows = useMemo(
    () => (year) => {
      const periodsInYear = availabelReportingPeriods.filter(
        (period) => period.year === year
      ).length;

      if (
        taxPaymentPeriod === TAX_PAYMENT_PERIOD_TYPES_ENUM.QUARTERLY ||
        taxPaymentPeriod === TAX_PAYMENT_PERIOD_TYPES_ENUM.NY_FISCAL
      ) {
        return `repeat(${Math.ceil(periodsInYear)}, 1fr)`;
      } else {
        return isMobile
          ? `repeat(${Math.ceil(periodsInYear / 2)}, 1fr)`
          : 'repeat(4, 1fr)';
      }
    },
    [taxPaymentPeriod, isMobile, availabelReportingPeriods]
  );

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={() => closeModal()}
    >
      <Modal.Header>
        <Modal.Title
          as="h2"
          className="text-bold no-padding-modal-section"
        >
          Report Additional Tax
        </Modal.Title>
        <Divider />
      </Modal.Header>
      {hasData ? (
        <>
          <Modal.Body>
            <Grid
              fluid
              className="no-padding-modal-section"
            >
              <Row className="mb-12">
                <Col xs={24}>
                  <Text className="mb-8">
                    Select the periods for which you wish to report tax,
                    including reporting $0.00 receipts.
                  </Text>
                </Col>
              </Row>
              <Row>
                <Col xs={24}>
                  <Tabs
                    defaultActiveKey={years[0].toString()}
                    appearance="subtle"
                  >
                    {years.map((year, index) => (
                      <Tabs.Tab
                        key={`year_tab_${index}`}
                        eventKey={year.toString()}
                        title={year}
                      >
                        <div
                          style={{
                            display: 'inline-grid',
                            gridAutoFlow: 'column',
                            gridTemplateColumns: gridTemplateColumn,
                            gridTemplateRows: gridTemplateRows(year),
                            rowGap: '15px',
                            columnGap: '60px',
                            marginTop: '8px',
                          }}
                        >
                          {availabelReportingPeriods
                            .filter((period) => period.year === year)
                            .map((period, index) => (
                              <div
                                key={`period_${index}`}
                                xs={12}
                              >
                                <BasicStyledCheckbox
                                  onChange={() => {
                                    updateAvailableReportingPeriods(period);
                                  }}
                                  checked={period.selected}
                                  label={period.label}
                                ></BasicStyledCheckbox>
                              </div>
                            ))}
                        </div>
                      </Tabs.Tab>
                    ))}
                  </Tabs>
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <Divider />
            <Grid
              fluid
              className="no-padding-modal-section"
            >
              <Row>
                <Col xs={24}>
                  <Button
                    type="button"
                    className="btn-primary"
                    onClick={() => closeModal()}
                  >
                    Add Periods
                  </Button>
                  <Button
                    onClick={() => closeModal()}
                    appearance="subtle"
                    className="btn-link-underline-hover"
                    style={{ padding: '8px 12px' }}
                  >
                    Close
                  </Button>
                </Col>
              </Row>
            </Grid>
          </Modal.Footer>
        </>
      ) : (
        <Modal.Body
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconIndicator />
        </Modal.Body>
      )}
    </ResponsiveModal>
  );
};

export default AddAdditionalPeriodsModal;
